import React, { useState } from "react";
import {
  Drawer,
  Box,
  Typography,
  IconButton,
  Collapse,
  InputBase,
  Checkbox,
  Slider,
  Button,
  Divider,
  Grid,
} from "@mui/material";
import { AddOutlined, Remove, FilterList, Close } from "@mui/icons-material";
import searchIcon from "../assets/browse-job/search-icon.svg";
import graphIcon2 from "../assets/browse-job/graph2.png";

const FilterDrawer = ({
  locations,
  specialities,
  onApplyFilters,
  onClearFilters,
  initialFilters = {},
  setIsOpen,
  isOpen,
  setSelectedSpecialties,
  selectedSpecialties,
  setPayRate,
  payRate,
  selectedLocations,
  setSelectedLocations,
  selectedShifts,
  setSelectedShifts,
}) => {
  // Drawer state

  // Section collapse states
  const [openSpecialty, setOpenSpecialty] = useState(true);
  const [openPayRate, setOpenPayRate] = useState(true);
  const [openLocation, setOpenLocation] = useState(true);
  const [openShift, setOpenShift] = useState(true);

  // Filter states
  //   const [selectedSpecialties, setSelectedSpecialties] = useState([]);
  //   const [payRate, setPayRate] = useState([1000, 50000]);
  //   const [selectedLocations, setSelectedLocations] = useState([]);
  //   const [selectedShifts, setSelectedShifts] = useState([]);

  // Search states
  const [searchQuery, setSearchQuery] = useState("");
  const [searchLocation, setSearchLocation] = useState("");

  const shifts = ["Day", "Night"];

  const handleToggle = (section) => {
    if (section === "specialty") setOpenSpecialty((prev) => !prev);
    if (section === "payRate") setOpenPayRate((prev) => !prev);
    if (section === "location") setOpenLocation((prev) => !prev);
    if (section === "shift") setOpenShift((prev) => !prev);
  };

  const handleSpecialtyChange = (specialty) => {
    setSelectedSpecialties((prev) =>
      prev.includes(specialty)
        ? prev.filter((item) => item !== specialty)
        : [...prev, specialty]
    );
  };

  const handleLocationChange = (location) => {
    setSelectedLocations((prev) =>
      prev.includes(location)
        ? prev.filter((item) => item !== location)
        : [...prev, location]
    );
  };

  const handleShiftChange = (shift) => {
    setSelectedShifts((prev) =>
      prev.includes(shift)
        ? prev.filter((item) => item !== shift)
        : [...prev, shift]
    );
  };

  const handlePayRateChange = (event, newValue) => {
    setPayRate(newValue);
  };

  const handleApplyFilters = () => {
    onApplyFilters({
      specialties: selectedSpecialties,
      pay_rate_min: payRate[0],
      pay_rate_max: payRate[1],
      locations: selectedLocations,
      shifts: selectedShifts,
    });
    setIsOpen(false);
  };

  const handleClearFilters = () => {
    setSelectedSpecialties([]);
    setPayRate([1000, 50000]);
    setSelectedLocations([]);
    setSelectedShifts([]);
    onClearFilters();
    setIsOpen(false);
  };

  // Filter locations and specialties based on search
  const filteredSpecialties = specialities?.filter((specialty) =>
    specialty.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const filteredLocations = locations?.filter((location) =>
    location.name.toLowerCase().includes(searchLocation.toLowerCase())
  );
  return (
    <>
      {/* Filter Button */}

      {/* Drawer */}
      <Drawer
        anchor="left"
        open={isOpen}
        onClose={() => setIsOpen(false)}
        sx={{
          display: { xs: "block", md: "none" },
          "& .MuiDrawer-paper": {
            width: "100%",
            maxWidth: "300px",
            px: 2,
            pb: 3,
          },
        }}
      >
        {/* Drawer Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            position: "sticky",
            top: 0,
            bgcolor: "#fff",
            zIndex: 999,
            pt: 2,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Filters
          </Typography>
          <IconButton onClick={() => setIsOpen(false)}>
            <Close />
          </IconButton>
        </Box>

        {/* Filter Sections - Same as FilterSidebar */}
        {/* Specialty Section */}
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Speciality
            </Typography>
            <IconButton size="small" onClick={() => handleToggle("specialty")}>
              {openSpecialty ? <Remove /> : <AddOutlined />}
            </IconButton>
          </Box>
          <Collapse
            in={openSpecialty}
            className="thin_slider"
            sx={{ maxHeight: "100px", overflowY: "auto" }}
          >
            <Box
              sx={{
                position: "sticky !important",
                top: 0,
                p: 1,
                display: "flex",
                alignItems: "center",
                border: "1px solid black",
                borderRadius: "10px !important",
                zIndex: 99,
                bgcolor: "#FFFFFF",
                my: 1,
              }}
            >
              <InputBase
                placeholder="Search specialties"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                fullWidth
                sx={{
                  fontSize: "0.7rem",

                  "input::placeholder": {
                    fontSize: "10px",
                  },
                }}
              />
            </Box>
            {filteredSpecialties?.map((specialty, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                sx={{ mb: 1 }}
              >
                <Checkbox
                  size="small"
                  checked={selectedSpecialties?.includes(specialty?.id)}
                  onChange={() => handleSpecialtyChange(specialty?.id)}
                />
                <Typography variant="body2">{specialty?.name}</Typography>
              </Box>
            ))}
          </Collapse>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Pay Rate Section */}
        <Box>
          <Box display="flex" justifyContent="space-between" mt={1} mb={2}>
            <Box sx={{ width: "45%" }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "0.7rem", xl: "17px" },
                  lineHeight: { xs: "20px", xl: "24px" },
                  fontFamily: "'Karla', sans-serif",
                  mb: 0.5,
                }}
              >
                Min (USD)
              </Typography>
              <InputBase
                value={payRate[0]}
                onChange={(e) => {
                  e.target.value >= 0 &&
                    setPayRate([+e.target.value, payRate[1]]);
                }}
                variant="outlined"
                sx={{
                  p: { xs: "2px 8px", xl: "8px 1rem" },
                  border: "1px solid #000000",
                  borderRadius: { xs: "4px" },

                  py: 0,
                  minHeight: "0px",
                  m: 0,
                  fontSize: "0.7rem",
                  height: "34px",
                }}
                placeholder=" "
                inputProps={{ "aria-label": "search by Nurses" }}
              />
            </Box>
            <Box sx={{ width: "45%" }}>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  fontSize: { xs: "0.7rem", xl: "17px" },
                  lineHeight: { xs: "20px", xl: "24px" },
                  fontFamily: "'Karla', sans-serif",
                  mb: 0.5,
                }}
              >
                Max (USD)
              </Typography>
              <InputBase
                value={payRate[1]}
                onChange={(e) => {
                  e.target.value >= 0 &&
                    setPayRate([payRate[0], +e.target.value]);
                }}
                variant="outlined"
                sx={{
                  p: { xs: "2px 8px", xl: "8px 1rem" },
                  border: "1px solid #000000",
                  borderRadius: { xs: "4px" },

                  py: 0,
                  minHeight: "0px",
                  m: 0,
                  fontSize: "0.7rem",
                  height: "34px",
                }}
                placeholder=" "
                inputProps={{ "aria-label": "search by Nurses" }}
              />
            </Box>
          </Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Pay rate range (hourly)
            </Typography>
            <IconButton size="small" onClick={() => handleToggle("payRate")}>
              {openPayRate ? <Remove /> : <AddOutlined />}
            </IconButton>
          </Box>
          <Collapse in={openPayRate}>
            <Box sx={{ px: 2 }}>
              <Slider
                value={payRate}
                onChange={handlePayRateChange}
                min={0}
                max={50000}
                valueLabelDisplay="auto"
                sx={{
                  color: "#E9C369",
                }}
              />
            </Box>
          </Collapse>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Location Section */}
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Location
            </Typography>
            <IconButton size="small" onClick={() => handleToggle("location")}>
              {openLocation ? <Remove /> : <AddOutlined />}
            </IconButton>
          </Box>
          <Collapse
            in={openLocation}
            className="thin_slider"
            sx={{ maxHeight: "100px", overflowY: "auto" }}
          >
            <Box
              sx={{
                position: "sticky !important",
                top: 0,
                p: 1,
                display: "flex",
                alignItems: "center",
                border: "1px solid black",
                borderRadius: "10px !important",
                zIndex: 99,
                bgcolor: "#FFFFFF",
                my: 1,
              }}
            >
              <InputBase
                placeholder="Search locations"
                value={searchLocation}
                onChange={(e) => setSearchLocation(e.target.value)}
                fullWidth
                sx={{
                  fontSize: "0.7rem",
                  "input::placeholder": {
                    fontSize: "10px",
                  },
                }}
              />
            </Box>
            {filteredLocations?.map((location, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                sx={{ mb: 1 }}
              >
                <Checkbox
                  size="small"
                  checked={selectedLocations?.includes(location?.id)}
                  onChange={() => handleLocationChange(location?.id)}
                />
                <Typography variant="body2">{location?.name}</Typography>
              </Box>
            ))}
          </Collapse>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Shift Type Section */}
        {/* <Box mb={5}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              Shift type
            </Typography>
            <IconButton size="small" onClick={() => handleToggle("shift")}>
              {openShift ? <Remove /> : <AddOutlined />}
            </IconButton>
          </Box>
          <Collapse in={openShift}>
            {shifts.map((shift, index) => (
              <Box
                key={index}
                display="flex"
                alignItems="center"
                sx={{ mb: 1 }}
              >
                <Checkbox
                  size="small"
                  checked={selectedShifts.includes(shift)}
                  onChange={() => handleShiftChange(shift)}
                />
                <Typography variant="body2">{shift}</Typography>
              </Box>
            ))}
          </Collapse>
        </Box> */}

        {/* Action Buttons */}
        <Box
          sx={{
            position: "fixed !important",
            bottom: 0,
            width: "100% !important",
            left: 0,
            p: 2,
            bgcolor: "background.paper",
            borderTop: "1px solid !important",
            borderColor: "divider !important",
            display: "flex",
            gap: 2,
            maxWidth: "300px",
          }}
        >
          <Button
            variant="outlined"
            sx={{ borderRadius: "10px !important" }}
            fullWidth
            onClick={handleClearFilters}
          >
            Clear
          </Button>
          <Button
            variant="contained"
            fullWidth
            onClick={handleApplyFilters}
            sx={{
              bgcolor: "#299B8D !important",
              borderRadius: "10px !important",
              "&:hover": {
                bgcolor: "#1E7B6E !important",
              },
            }}
          >
            Apply
          </Button>
        </Box>
      </Drawer>
    </>
  );
};

export default FilterDrawer;
